import { render, staticRenderFns } from "./KEYPAD.vue?vue&type=template&id=ff2024c4"
import script from "./KEYPAD.vue?vue&type=script&lang=js"
export * from "./KEYPAD.vue?vue&type=script&lang=js"
import style0 from "./KEYPAD.vue?vue&type=style&index=0&id=ff2024c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports